export default "__VITE_ASSET__ac0f18cc__"